import './hto-payment.scss';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
// actions
import config from '../../../../config';
import { applyCode } from '../../../../actionCreators/cart';
// components
import { Field } from 'react-final-form';
import { debounce } from '../../../../utils/helper';
import Loader from '../../../Loader/Loader';

const Radio = ({ input, children, disabled, click, className, paymentType }) => {
    return (
        <label className={className} onClick={e => click(e, paymentType)}><input type="radio" {...input} disabled={disabled} /> {children}</label>
    );
};

function HTOPayment(props) {
    const [totalAmount, setTotalAmount] = useState('');
    const [discount, setDiscount] = useState(0);
    const [isCouponApplied, setIsCouponApplied] = useState(false);
    const [defaultDiscount, setDefaultDiscount] = useState();
    const [chosenPayType, setChosenPayType] = useState({type: 'online', methodManualUpdated: false });

    const addRemoveCoupon = (isRemove, payType, manualUpdate) => {
        const code = props.values.couponCode;
        const defaultCouponCode = props.cartData.totals.discounts.length ? props.cartData.totals.discounts[0].code : props.htoConfig.coupon.code;
        if (isRemove) {
            setIsCouponApplied(false);
            setChosenPayType({type: payType || chosenPayType, methodManualUpdated: manualUpdate || false });
            props.deleteCoupon(code || defaultCouponCode);
            props.mutators.setValue('couponCode', '');
        } else if (code) {
            setIsCouponApplied(true);
            props.applyCoupon(code.toUpperCase());
        }
    };

    const onChangePaymentMethod = debounce((...args) => {
        const type = args[1];
        if (chosenPayType.type === type) return;

        setChosenPayType({type: args[1], methodManualUpdated: true });
        const isCouponAppliedInCard = props.cartData.totals.discounts.length;
        const defaultCouponCode = isCouponAppliedInCard ? props.cartData.totals.discounts[0].code : props.htoConfig.coupon.code;

        if (isCouponAppliedInCard) {
            setIsCouponApplied(false);
            props.deleteCoupon(defaultCouponCode);
            props.mutators.setValue('couponCode', '');
        }
        // When user applied coupon with COD and chose online again
        // First param is for removing exising applied coupon code
        // Second param selected payment mehtod by user
        // third param is if user has updated the payment method
        // if (type === 'online' && isCouponAppliedInCard) addRemoveCoupon(true, 'online', true);

        if (type === 'online' && !isCouponAppliedInCard) {
            setIsCouponApplied(true);
            props.mutators.setValue('couponCode', '');
            props.applyCoupon(props.htoConfig.coupon.code);
        }
        // if (type === 'cod' && isCouponApplied) {
        //     setIsCouponApplied(false);
        //     props.deleteCoupon(defaultCouponCode || props.htoConfig.coupon.code);
        //     props.mutators.setValue('couponCode', '');
        // }

    }, 100);
    useEffect(() => {
        if (props.cartData && props.cartData.cartId) {
            if (props.cartData.totals) {
                const coupon = props.cartData.totals.discounts.find(discount => discount.type === 'gv');
                setTotalAmount(props.cartData.totals.total);
                setIsCouponApplied(Boolean(coupon));
                if (coupon) {
                    setDiscount(coupon.amount);
                    if (!defaultDiscount) setDefaultDiscount(coupon.amount);
                } else {
                    setIsCouponApplied(false);
                    setDiscount(0);
                }
            }
        }
        // else if (props.isCartDataLoaded) {
        //     console.log('df');
        //     props.navTo('');
        // }
        if (props.cartData.totals && !props.cartData.totals.discounts.length && chosenPayType.methodManualUpdated && chosenPayType.type === 'online') {
            props.applyCoupon(props.htoConfig.coupon.code);
            setChosenPayType({type: 'online', methodManualUpdated: true });
        }
    }, [props.cartData]);

    const prevcartErr = useRef(props.cartErr);
    useEffect(() => {
        if (prevcartErr && props.cartErr) {
            setIsCouponApplied(false);
        }
    }, [props.cartErr]);

    return (
        <div className="hto-payment pd-10 margin-t20">
            <div className="hto-payment-method flex-1 pd-b15">
                <h5 className="text-uppercase fsp14 fw500 mr-b10 pd-t10">Please Select Payment Mode</h5>
                <Field className="display-block margin-b10 fsp14" name="paymentType" type="radio" value="online" component={Radio} click={onChangePaymentMethod} paymentType="online"> Pay Online </Field>
                <Field className="display-block margin-b10 fsp14" name="paymentType" type="radio" value="cod" component={Radio} click={onChangePaymentMethod} paymentType="cod"> Pay Via Cash {defaultDiscount && <span className="text-color-black fs14 fsp14 pd-l5">(&#x20B9;{`${defaultDiscount} ${props.htoConfig.coupon.warningText}`})</span>} </Field>
                <Field name="couponCode">
                    {({ input }) => (
                        <div className="form-group apply-coupon">
                            <input {...input} type="text" className={`${isCouponApplied ? 'disabled' : ''} form-control`} maxLength="200" placeholder={`${isCouponApplied ? 'Prepaid discount Coupon Applied' : 'Enter Coupon Code'}`} disabled={isCouponApplied} />
                            <button type="button" onClick={() => addRemoveCoupon(isCouponApplied)} className="hto-btn hto-btn__primary apply-btn">{isCouponApplied ? 'Remove' : 'Apply'}</button>
                        </div>
                    )}
                </Field>
                {props.cartErr && <span className="block margin-t4 fs10 mr-t4 fsp10 fw-700 text-color_brick_red">{props.cartErr.message}</span>}
            </div>
            <div className="hto-payment-section-divider"></div>
            <div className="hto-payment-details mr-t10 flex-1">
                {!props.isCartDataLoaded && <Loader />}
                {props.isCartDataLoaded && <div>
                    <h5 className="text-uppercase fsp14 fw500 mr-b10 show-amount pd-t10">Total Amount</h5>
                    <div className="hto-amount text-center fw400">&#x20B9; {totalAmount} {discount > 0 && <span className="pd-l5 padding-l5 fs20 fsp16 text-color_pale_black text-color-grey strike-through">{totalAmount + discount}/-</span>}</div>
                    <button type="submit" className="hto-btn hto-btn__primary payment-submit">Confirm Booking</button>
                    </div>}
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    htoConfig: state.hto.htoConfig,
    cartData: state.cart.cartData.result,
    isCartDataLoaded: state.cart.isCartDataLoaded,
    cartErr: state.cart.error
});

const mapDispatchToProps = dispatch => ({
    applyCoupon: code => dispatch(applyCode(`${config.apiPath.applyGV}${code}?applyWallet=false`, 'post')),
    deleteCoupon: code => dispatch(applyCode(`${config.apiPath.applyGV}${code}?applyWallet=false`, 'delete'))
});

export default connect(mapStateToProps, mapDispatchToProps)(HTOPayment);
